import { Controller } from "@hotwired/stimulus"

// Clamps long content (the strategy document) to a preview height with a fade,
// toggled open by a labeled button. The label swaps between show/hide.
export default class extends Controller {
  static targets = ["content", "more", "less", "indicator"]

  toggle(event) {
    const open = this.contentTarget.classList.toggle("clamp--open")
    if (this.hasMoreTarget) this.moreTarget.classList.toggle("hidden", open)
    if (this.hasLessTarget) this.lessTarget.classList.toggle("hidden", !open)
    if (this.hasIndicatorTarget) this.indicatorTarget.classList.toggle("rotate-180", open)
    event.currentTarget.setAttribute("aria-expanded", open.toString())
  }
}
